"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLive = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var StyledSVG = _styledComponents.default.svg.withConfig({
  displayName: "DomestikaLive__StyledSVG",
  componentId: "dpe9eu-0"
})(["", ""], _styledSystem.layout);

var DomestikaLive = function DomestikaLive(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return React.createElement(StyledSVG, {
    width: width,
    height: height,
    viewBox: "0 0 224 33",
    preserveAspectRatio: "xMidYMid meet"
  }, React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Domestika-Live---MVP---Desktop",
    transform: "translate(-129.000000, -48.000000)",
    fill: "#F02D00"
  }, React.createElement("g", {
    id: "Group-10",
    transform: "translate(129.000000, 48.000000)"
  }, React.createElement("g", {
    id: "Domestika-Live---Icon"
  }, React.createElement("path", {
    d: "M91.2800082,9.66000086 C93.3000083,9.68000087 95.2000085,10.3600009 96.5400086,11.500001 C98.2400088,12.9600012 98.7400088,14.5000013 98.8800088,14.9200013 L98.8800088,14.9200013 L98.9000088,14.9800013 L94.8200085,16.6800015 L94.7200085,16.4400015 C94.7200085,16.4400015 94.4200084,15.7800014 93.7200084,15.0200013 C93.2000083,14.4400013 92.2600074,14.0800013 91.2600074,14.0800013 C90.1800081,14.0800013 89.240008,14.4800013 88.7200079,15.1400014 C87.8600079,16.2600015 88.5600079,17.4800016 88.9000079,17.8000016 C89.560008,18.4000016 90.4200081,18.6000017 91.5000082,18.8600017 C92.6400083,19.1200017 94.0000084,19.4800017 95.6800086,20.4000018 C98.8800088,22.160002 100.000009,25.5200023 98.5200088,28.5600026 C97.2800087,31.1400028 94.6000085,32.6600029 91.3600082,32.6200029 C89.480008,32.6000029 87.5800078,32.0600029 86.1400077,31.0800028 C84.3000075,29.8400027 83.5600075,28.1600025 83.2600074,27.4400025 L83.2600074,27.4400025 L87.3800078,25.7200023 C88.2800079,27.8000025 90.0800081,28.2000025 91.4400082,28.2200025 C91.5800082,28.2200025 91.7200082,28.2200025 91.8800082,28.2000025 C93.0200083,28.1400025 94.3200084,27.3400024 94.5200085,26.1200023 C94.6600085,25.2600023 94.1600084,24.5400022 93.1400083,24.1000022 C92.1600082,23.7000021 91.4800082,23.5200021 90.7600074,23.3200021 C89.880008,23.0800021 88.980008,22.860002 87.5200078,22.180002 C85.6200077,21.3000019 84.3000075,19.7000018 83.8600075,17.8000016 C83.4200075,15.8600014 83.9600075,13.8800012 85.3400076,12.1800011 C86.6200077,10.5600009 88.8000079,9.64000086 91.2800082,9.66000086 Z",
    id: "Path"
  }), React.createElement("polygon", {
    id: "Path",
    points: "131.760012 10.1200009 131.760012 19.8400018 138.980012 10.1200009 144.360013 10.1200009 136.720012 20.5400018 144.440013 32.1000029 139.060012 32.1000029 133.900012 24.3800022 131.760012 27.3400024 131.760012 32.1000029 127.380011 32.1000029 127.380011 10.1200009"
  }), React.createElement("polygon", {
    id: "Path",
    points: "82.4000074 10.1200009 82.4000074 14.4600013 71.2400064 14.4600013 71.2400064 18.9400017 80.2800072 18.9400017 80.2800072 23.2800021 71.2400064 23.2800021 71.2400064 27.7400025 82.4000074 27.7400025 82.4000074 32.1000029 66.880006 32.1000029 66.880006 10.1200009"
  }), React.createElement("polygon", {
    id: "Path",
    points: "118.020011 10.1200009 118.020011 14.5800013 111.14001 14.5800013 111.14001 32.1000029 106.66001 32.1000029 106.66001 14.5800013 99.8000089 14.5800013 99.8000089 10.1200009"
  }), React.createElement("polygon", {
    id: "Path",
    points: "48.7800044 10.1200009 54.3200049 20.4400018 59.8800054 10.1200009 64.8800058 10.1200009 64.8800058 32.1000029 60.4400054 32.1000029 60.4400054 18.2200016 54.3200049 29.5400026 48.2200043 18.2200016 48.2200043 32.1000029 43.7800039 32.1000029 43.7800039 10.1200009"
  }), React.createElement("rect", {
    id: "Rectangle",
    x: "120.280011",
    y: "10.1200009",
    width: "4.4400004",
    height: "21.960002"
  }), React.createElement("path", {
    d: "M31.1400028,9.82000088 C37.3600018,9.82000088 42.4200038,14.9000013 42.4200038,21.1600019 C42.4200038,27.4200025 37.3600018,32.5000029 31.1400028,32.5000029 C24.9200022,32.5000029 19.8600018,27.4200025 19.8600018,21.1600019 C19.8600018,14.9200013 24.9200022,9.82000088 31.1400028,9.82000088 Z M31.1400028,14.4600013 C27.4600022,14.4600013 24.4600022,17.4800016 24.4600022,21.1800019 C24.4600022,24.9000022 27.4600022,27.9200025 31.1400028,27.9200025 C34.8200031,27.9200025 37.8200034,24.9000022 37.8200034,21.1800019 C37.8200034,17.4600013 34.8200031,14.4600013 31.1400028,14.4600013 Z",
    id: "Shape"
  }), React.createElement("path", {
    d: "M7.8200007,10.1000009 C13.8400012,10.1000009 18.7200017,15.0200013 18.7200017,21.0800019 C18.7200017,27.1400024 13.8200012,32.0600029 7.8200007,32.0600029 L7.8200007,32.0600029 L0,32.0600029 L0,10.1000009 L7.8200007,10.1000009 Z M7.8600007,14.6200013 L4.4400004,14.6200013 L4.4400004,27.5400025 L7.8600007,27.5400025 C11.400001,27.5400025 14.2800013,24.6400022 14.2800013,21.0600019 C14.2800013,17.5200016 11.400001,14.6200013 7.8600007,14.6200013 L7.8600007,14.6200013 Z",
    id: "Shape"
  }), React.createElement("path", {
    d: "M157.100014,10.1200009 L164.880015,32.0800029 L164.880015,32.0800029 L160.300014,32.0800029 L158.660014,27.4200025 L150.900013,27.4200025 L149.260013,32.0800029 L144.680013,32.0800029 L152.400014,10.1200009 L157.100014,10.1200009 Z M154.760014,16.4400015 L152.400014,23.1000021 L157.100014,23.1000021 L154.760014,16.4400015 Z",
    id: "Shape"
  }), React.createElement("polygon", {
    id: "Path",
    points: "173.940016 11.100001 173.940016 21.2200019 179.460016 21.2200019 179.460016 23.1000021 171.800015 23.1000021 171.800015 11.100001"
  }), React.createElement("rect", {
    id: "Rectangle",
    x: "182.200016",
    y: "11.100001",
    width: "2.16000019",
    height: "12.0000011"
  }), React.createElement("polygon", {
    id: "Path",
    points: "189.420017 11.100001 192.460017 20.6000018 192.600017 20.6000018 195.620017 11.100001 197.920018 11.100001 193.740017 23.1000021 191.240017 23.1000021 187.040017 11.100001"
  }), React.createElement("polygon", {
    id: "Path",
    points: "208.400019 11.100001 208.400019 12.9800012 202.740018 12.9800012 202.740018 16.1600014 208.080019 16.1600014 208.080019 17.9000016 202.740018 17.9000016 202.740018 21.2400019 208.400019 21.2400019 208.400019 23.1000021 200.600018 23.1000021 200.600018 11.100001"
  }), React.createElement("polygon", {
    id: "Path",
    points: "77.5600069 0.100000009 79.9200071 3.66000033 77.1200069 7.46000067 72.1600065 7.46000067 69.3600062 3.64000033 71.7200064 0.100000009 74.6400067 4.08000036"
  }))))));
};

exports.DomestikaLive = DomestikaLive;
DomestikaLive.defaultProps = {
  width: ['176px', '223px', '223px'],
  height: ['26px', '33px', '33px']
};